(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorDialogController', GestorDialogController);

GestorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Gestor', 'Unidadegestor', 'Pessoa', 'Propriedade', 'Unidade', 'User'];

    function GestorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Gestor, Unidadegestor, Pessoa, Propriedade, Unidade, User) {
        var vm = this;

        vm.gestor = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.unidadegestors = Unidadegestor.query();
        vm.unidades = Unidade.query({
            size:1000
        });
        
        vm.onSaveUser = onSaveUser;
        vm.onSavePessoa = onSavePessoa;
        vm.onSaveSuccess = onSaveSuccess;
        vm.onUpdateSuccess = onUpdateSuccess;

        vm.listaUnidadesAntigas = [];

        vm.onSucessoUnidadesAssociadas = onSucessoUnidadesAssociadas;
        vm.onSucessoUGs = onSucessoUGs;

        vm.gestor_id = null;

        if(vm.gestor.id != null){
        	var idGestor = parseInt(vm.gestor.id);
        	Unidade.queryUnidadesAssociadas({idgestor: idGestor, size:1000}, onSucessoUnidadesAssociadas);
        	Unidadegestor.queryUGsAssociadas({idgestor: idGestor, size:1000}, onSucessoUGs);
        }
        
        function onSucessoUnidadesAssociadas(result){
        	vm.gestor.unidade = result;
        	vm.listaUnidadesAntigas = result;
        }
        
        function onSucessoUGs(result){
        	vm.listaUGs = result;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gestor.id !== null) {
                Gestor.update(vm.gestor, onUpdateSuccess, onSaveError);
            } else {
                vm.gestor_id = null;
                Gestor.save(vm.gestor, onSaveSuccess, onSaveError);
            }
        }

        // Criação do usuário
        function onSaveSuccess (result) {
            vm.gestor_id = result.id;
            vm.novousuario = new User();
            vm.novousuario.login = vm.gestor.login;
            vm.novousuario.firstName = vm.gestor.nome;
            vm.novousuario.lastName = vm.gestor.sobrenome; 
            vm.novousuario.email = vm.gestor.email;
            vm.novousuario.authorities = [];
            vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
            User.save(vm.novousuario, onSaveUser, onSaveError);
        }

        // Criação da Pessoa
        function onSaveUser(result) {
            vm.novapessoa = new Pessoa();
            vm.novapessoa.nome = vm.gestor.nome;
            vm.novapessoa.sobrenome = vm.gestor.sobrenome;
            vm.novapessoa.cpf = vm.gestor.cpf;
            vm.novapessoa.cargo = "gestorparceiro";
            vm.novapessoa.email = vm.gestor.email;
            vm.novapessoa.login = vm.gestor.login;
            Pessoa.save(vm.novapessoa, onSavePessoa, onSaveError);
        }
        
        vm.PPsDelete = [];
        vm.PPsUpdate = [];
        vm.PPsCreate = [];
        vm.pessoa_id = null;

        // Criaçao de UnidadeGestor
        function onSavePessoa(result){
            vm.pessoa_id = result.id;

            if(vm.gestor.unidade.length > 0){
                var VetorUGs = [];

                for(var i=0; i<vm.gestor.unidade.length; i++){
                    var UG = new Unidadegestor();
                    UG.gestor = new Gestor();
                    UG.unidade = new Unidade();

                    UG.gestor.id = vm.gestor_id;
                    UG.unidade.id = vm.gestor.unidade[i].id;

                    VetorUGs.push(UG);
                }

                Unidadegestor.acao({acao: "create"}, VetorUGs, vm.onSaveUGs);
            }
            else{
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        vm.PPsCreate = [];

        vm.onSaveUGs = function onSaveUGs() { 
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        
        function onUpdateSuccess(result){
        	console.log(vm.listaUGs);
        	console.log(vm.listaUnidadesAntigas);
            vm.UGsDelete = [];
            
			var sumiu = null;
        	
        	for (var i = 0; i < vm.listaUnidadesAntigas.length; i++) {
        		
        		var idUnidadeAnterior = vm.listaUnidadesAntigas[i].id;
        		sumiu = true;
				
				for (var j = 0;  j < vm.gestor.unidade.length; j++) {
					var comparativo = vm.gestor.unidade[j].id;
					
					if(idUnidadeAnterior == comparativo){
						sumiu = false;
						break;
					}	
				}
			
				if(sumiu == true){
					for(var j = 0; j < vm.listaUGs.length; j++){
						var idUnidade = vm.listaUGs[j].unidade.id ;
						if(idUnidade == idUnidadeAnterior){
                            var temp = new Unidadegestor();
                            temp.id = vm.listaUGs[j].id;
							vm.UGsDelete.push(temp);
						}
					}
				}
        	}
        	
            var existia = null;
            vm.UGsUpdate = [];
            vm.UGsCreate = [];
        	
        	for (var i = 0; i < vm.gestor.unidade.length; i++) {
        		
        		var idComparativo = vm.gestor.unidade[i].id;
        		existia = false;
				
				for (var j = 0;  j < vm.listaUnidadesAntigas.length; j++) {
					var idUnidadeAntiga = vm.listaUnidadesAntigas[j].id;
					
					if(idComparativo == idUnidadeAntiga){
						existia = true;
						break;
					}	
				}
			
				if(existia == false){
					var novo = new Unidadegestor();
					novo.unidade = new Unidade();
					novo.gestor = new Gestor();
					novo.unidade.id = idComparativo;
					novo.gestor.id = vm.gestor.id;
					vm.UGsCreate.push(novo);
				}
            }
            
            Unidadegestor.acao({acao: "delete"}, vm.UGsDelete, function(){
                console.log("Delete");
                Unidadegestor.acao({acao: "create"}, vm.UGsCreate, function(){
                    console.log("Create");
                    //$scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    //$uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            });
        	
        	
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onSaveUGs(result) {

        }

        vm.setFoto = function ($file, gestor) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        gestor.foto = base64Data;
                        gestor.fotoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

// FINALIZAÇÃO
//$scope.$emit('netWordAgroApp:pessoaUpdate', result);
//$uibModalInstance.close(result);
